import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { SnackBarComponent } from '@shared/snack-bar/snack-bar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  private readonly duration = 5000;

  constructor(private snackBar: MatSnackBar) {}

  public error(message: string, duration?: number): void {
    this.openSnackBar('error', message, duration);
  }

  public success(message: string, duration?: number): void {
    this.openSnackBar('success', message, duration);
  }

  private openSnackBar(
    level: string,
    message: string,
    customDuration?: number,
  ): void {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: { level, message },
      duration: customDuration || this.duration,
    });
  }
}
